/* Product-card image slider — swipe (native scroll-snap) + arrows + dots.
   ~1KB. Runs only where [data-card-slider] exists. */
(function () {
  var canHover = window.matchMedia('(hover: hover)').matches;

  document.querySelectorAll('[data-card-slider]').forEach(function (slider) {
    var slides = Array.prototype.slice.call(slider.children);
    if (slides.length < 2) return;

    var media = slider.parentElement;
    var prev = media.querySelector('[data-card-prev]');
    var next = media.querySelector('[data-card-next]');
    var dotsWrap = media.querySelector('[data-card-dots]');
    // Second image that fades in on hover (product-card). While it shows, it
    // stands in for slide 2, so arrows and dots treat it as such.
    var hoverImg = media.querySelector('.card__hover-img');

    function step() { return slider.getBoundingClientRect().width; }
    function index() {
      var i = Math.round(slider.scrollLeft / step());
      return Math.max(0, Math.min(slides.length - 1, i));
    }
    function hoverShown() {
      return !!hoverImg && canHover && media.matches(':hover') && !media.classList.contains('is-browsed');
    }
    function hideHover(instant) {
      if (instant) hoverImg.style.transition = 'none';
      media.classList.add('is-browsed');
      if (instant) { void hoverImg.offsetWidth; hoverImg.style.transition = ''; }
    }

    // Slide an arrow click is still scrolling to, so quick repeat clicks keep
    // advancing instead of re-targeting the same slide. Cleared once scrolling settles.
    var pending = null, settle;
    function go(d, e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      var from = pending !== null ? pending : index();
      if (hoverShown()) {
        if (d < 0) { hideHover(false); update(); return; } // back to slide 1
        slider.scrollLeft = step();                        // jump under it to slide 2…
        hideHover(true);                                   // …so hiding it is seamless
        from = 1;
      }
      pending = Math.max(0, Math.min(slides.length - 1, from + d));
      slider.scrollTo({ left: pending * step(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function (e) { go(-1, e); });
    if (next) next.addEventListener('click', function (e) { go(1, e); });

    var dots = dotsWrap ? slides.map(function () {
      var d = document.createElement('span');
      d.className = 'card__dot';
      dotsWrap.appendChild(d);
      return d;
    }) : [];
    function update() {
      var idx = index();
      if (hoverImg && idx > 0) media.classList.add('is-browsed');
      var shown = hoverShown() ? 1 : idx;
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === shown); });
    }
    update();
    var raf;
    slider.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
      clearTimeout(settle);
      settle = setTimeout(function () { pending = null; }, 150);
    }, { passive: true });

    if (hoverImg && canHover) {
      media.addEventListener('mouseenter', update);
      media.addEventListener('mouseleave', function () {
        if (index() === 0) media.classList.remove('is-browsed');
        update();
      });
    }
  });
})();
